/**
 * fix sticky table column width
 */
import React, { useLayoutEffect, useRef } from 'react';

import styles from './index.module.scss';

// 提取表格标题文本
const extractTitleList = (list) => {
  let result = [];
  list.forEach((item) => {
    if (item.children && item.children.length) {
      result = result.concat(extractTitleList(item.children));
    } else {
      result.push(item.title);
    }
  });
  return result;
};

const Index: React.FC = (props) => {
  const tableWrapperRef = useRef<HTMLDivElement>();
  const propsRef = useRef({
    columnTitleList: [], // 标题文本
    dataSource: [], // 数据源
  });

  // 属性更新
  const updateTableRef = () => {
    try {
      const tableNode: any = React.Children.only(props.children);
      const titleTextList = extractTitleList(tableNode.props.columns || []); // 标题 纯文本
      if (typeof tableNode.props.rowSelection !== 'undefined') {
        titleTextList.unshift('RS'); // fix rowSelection
      }
      if (propsRef.current.columnTitleList.join(' ') !== titleTextList.join(' ')) {
        // 标题变更
        propsRef.current.columnTitleList = titleTextList;
      }
      if (propsRef.current.dataSource !== tableNode.props.dataSource) {
        // 数据变更
        propsRef.current.dataSource = tableNode.props.dataSource;
      }
    } catch (_) {
      //
    }
  };

  updateTableRef();

  useLayoutEffect(() => {
    try {
      const titleTextList = propsRef.current.columnTitleList;
      const measureNodeList = tableWrapperRef.current
        .querySelector('.ant-table-measure-row')
        .querySelectorAll('div');
      [].forEach.call(measureNodeList, (item, idx) => {
        // 表格内容撑开
        // eslint-disable-next-line no-param-reassign
        item.textContent = titleTextList[idx];
        // 样式覆盖
        // eslint-disable-next-line no-param-reassign
        item.className = styles.measureColumnCell;
      });
    } catch (e) {
      //
    }
  }, [propsRef.current.columnTitleList]);

  useLayoutEffect(() => {
    try {
      const headerTable: HTMLTableColElement = tableWrapperRef.current.querySelector(
        '.ant-table-header table',
      );
      headerTable.style.tableLayout = 'fixed';
      if ((propsRef.current.dataSource || []).length === 0) {
        // 表格数据为空时 撑开表头内容
        headerTable.style.tableLayout = 'auto';
      }
    } catch (_) {
      //
    }
  }, [propsRef.current.dataSource]);

  return (
    <div ref={tableWrapperRef} className={styles.stickyTableWrapper}>
      {props.children}
    </div>
  );
};

export default Index;
